// frontend/src/pages/iqgames/fanratings/FanRatingsMyRatings.jsx

import React, { useEffect, useState } from "react";
import useFanRatingsHook from "./useFanRatingsHook";

const FanRatingsMyRatings = ({ onBack }) => {
  const { getMyRatings } = useFanRatingsHook();
  const [loading, setLoading] = useState(true);
  const [ratings, setRatings] = useState([]);

  useEffect(() => {
    loadMyRatings();
  }, []);

  const loadMyRatings = async () => {
    try {
      setLoading(true);

      const response = await getMyRatings();

      if (response?.success) {
        setRatings(response.data || []);
      } else {
        setRatings([]);
      }
    } catch (error) {
      console.error("FanRatings My Ratings Error:", error);
      setRatings([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="py-16 text-center">
        <p className="text-gray-50 text-sm">Loading your ratings...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-purple-950 p-4">
      <button
        onClick={onBack}
        className="mb-4 rounded-lg bg-fuchsia-700 hover:bg-fuchsia-600 text-white text-xs w-fit px-4 py-2"
      >
        ← Back
      </button>

      <div className="rounded-xl bg-purple-900 border border-fuchsia-700 p-5">
        <h1 className="text-xl font-bold text-gray-50">⭐ My Fan Ratings</h1>

        <p className="text-xs text-gray-100 mt-2">
          Track all campaigns where you have participated.
        </p>
      </div>

      <div className="mt-5 space-y-4">
        {ratings.map((rating) => (
          <div
            key={rating._id}
            className="rounded-xl bg-purple-900 border border-fuchsia-700 p-4"
          >
            <div className="flex justify-between gap-3">
              <div>
                <h3 className="text-sm font-semibold text-gray-50">
                  {rating.title}
                </h3>

                <p className="text-xs text-gray-100 mt-1">{rating.category}</p>
              </div>

              <div className="text-right">
                <p className="text-yellow-400 font-bold">
                  ⭐{" "}
                  {rating.userResponse
                    .split(",")
                    .map(Number)
                    .reduce((a, b) => a + b, 0) /
                    rating.userResponse.split(",").length}
                </p>

                <span
                  className={`text-[10px] px-2 py-1 rounded-full ${
                    rating.status === "Published"
                      ? "bg-green-700 text-white"
                      : "bg-orange-700 text-white"
                  }`}
                >
                  Submitted
                </span>
              </div>
            </div>

            <div className="mt-4 border-t border-fuchsia-900 pt-3">
              <p className="text-xs text-gray-100">Submitted On</p>

              <p className="text-sm text-white">
                {new Date(rating.createdAt).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FanRatingsMyRatings;
